import { z } from 'zod';
export const storeSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  address: z.string().min(1, 'Address is required'),
  gstin: z.string().optional(),
  default_warehouse_id: z.string().uuid().optional(),
});
export type StoreInput = z.infer<typeof storeSchema>;
